<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('facturation.facturation') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content pd-40px">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :withEmplyFields="true"
                           :error="error"
                           :title="'editionFacture.problemOccurred'"
                           @close="error = $event"/>
      <div class="columns is-multiline">
        <b-field :label="$t('facturation.date')"
                 class="column is-12 mgb-0">
          <b-datepicker show-week-number
                        v-model="dateFacturation"
                        icon="calendar-today"
                        editable
                        nearby-selectable-month-days
                        position="is-bottom-left">
          </b-datepicker>
        </b-field>
        <div class="column is-12" v-if="echeances.length > 1">
          <b-checkbox v-model="genererUneSeuleFacture">
            <span class="has-text-default">
              {{ $t('facturation.genererUneSeuleFacture') }}
            </span>
          </b-checkbox>
        </div>
        <div class="column is-12">
          <b-checkbox v-model="genererFactureZero">
            <span class="has-text-default">
              {{ $t('facturation.genererFactureZero') }}
            </span>
          </b-checkbox>
        </div>
      </div>
      <footer class="mgt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="generefacture()">
              {{ $t('facturation.actions.facturer') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import validationCreationfacture from '@/services/devisCommandes/validation/validationCreationFacture';
import translate from '@/services/commande/facturation/translator';
import validation from '@/services/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { factureGeneration } from '@/api/facture';
import formatDate from '@/services/general/formatIsoDate';
import validationChampsObligatoireFacture from '@/services/devisCommandes/validation/validationChampsObligatoireFacture';

export default {
  name: 'facturerEcheances',
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      dateFacturation: new Date(),
      error: false,
      messagesChampsVide: [],
      champsVide: [],
      messages: [],
      genererUneSeuleFacture: false,
      genererFactureZero: false,
    };
  },
  props: {
    echeances: Array,
  },
  methods: {
    async generefacture() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messages = [];
        this.error = false;
        const factures = (await factureGeneration(
          {
            listeEcheancierLigneId: this.echeances.map((el) => el.id),
            dateFacturation: formatDate(this.dateFacturation),
            calculeEnQuantite: false,
            genererUneSeuleFacture: this.genererUneSeuleFacture,
            genererFactureZero: this.genererFactureZero,
          },
        )).data.result;
        if (factures.length === 1) {
          messageSucces(this.$i18n.t('facturation.messages.success.echeanceFacturee'));
          loadingComponent.close();
          await this.$router.push({ name: 'm.bodac.factures-edition', params: { id: factures[0].id } });
          return;
        }
        if (factures.length === 0) messageSucces(this.$i18n.t('facturationCommande.facturationCommandeZero'));
        else messageSucces(this.$i18n.t('facturation.messages.success.multiEcheancesFacturees', { nb: factures.length }));
        loadingComponent.close();
        this.$emit('reloadEcheanciers');
      } catch (e) {
        if (e.response.data.error) {
          validationCreationfacture(e.response, this.messages);
          validationChampsObligatoireFacture(e.response, this.messages);
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
};
</script>

<style scoped>

</style>
